import { render, staticRenderFns } from "./TheInfo.vue?vue&type=template&id=22c50976&scoped=true&"
import script from "./TheInfo.vue?vue&type=script&lang=js&"
export * from "./TheInfo.vue?vue&type=script&lang=js&"
import style0 from "./TheInfo.vue?vue&type=style&index=0&id=22c50976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c50976",
  null
  
)

export default component.exports